// components/Footer.js

import React from "react";
import styles from "./Footer.module.css";

function Footer() {
  return (
    <footer className={styles.footer}>
      <p>&copy; 2026. All rights reserved.</p>
    </footer>
  );
}

export default Footer;
